/* eslint-disable no-param-reassign,@typescript-eslint/no-unused-vars */

import { DESIGNER_EVENTS } from '../../../../../app/constants/designer_events';

(function (angular) {
  angular.module('xplenty-designer').directive('designerContextMenu', [
    function () {
      return {
        templateNamespace: 'html',
        restrict: 'E',
        // eslint-disable-next-line global-require
        template: require('./designer-context-menu.html'),
        replace: true,
        scope: {
          designer: '=',
        },
        link(scope, element, attrs) {
          scope.items = [];

          scope.$on(DESIGNER_EVENTS.CONTEXT_MENU_SHOW, function (event, context) {
            element.css({
              top: context.top,
              left: context.left,
            });
            scope.items = context.items;
            scope.$apply();
            element.show();
          });
          scope.$on(DESIGNER_EVENTS.CONTEXT_MENU_HIDE, function (event, context) {
            element.css({
              top: 0,
              left: 0,
            });
            scope.items = [];
            element.hide();
          });
        },
      };
    },
  ]);
})(window.angular);
